import React from 'react'

function Destination() {
 return (
 <div>
 <div className="container-fluid bg-primary py-5 mb-5 hero-header">
 <div className="container">

   <div className="row justify-content-center">
 <div className="col-lg-10 text-center">
 <h1 className="display-3 text-white animated slideInDown">
 Destination
 </h1>
 <nav aria-label="breadcrumb">
 <ol className="breadcrumb justify-content-center">
 <li className="breadcrumb-item">
 <a href="/">Accueil</a>
 </li>
 <li
 className="breadcrumb-item text-white active"
 aria-current="page"
 >
 Destination
 </li>
 </ol>
 </nav>
 </div>
 </div>
 </div>
 </div>
 {/* Destination Start */}
 <div className="container-xxl py-5 destination">
 <div className="container">
 <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
 <h6 className="section-title bg-white text-center text-primary px-3">
 Destination
 </h6>
 <h1 className="mb-5">Destination populaire</h1>
 </div>
 <div className="row g-3">
 <div className="col-lg-7 col-md-6">
 <div className="row g-3">
 <div
 className="col-lg-12 col-md-12 wow zoomIn"
 data-wow-delay="0.1s"
 >
 <a
 className="position-relative d-block overflow-hidden"
 href=""
 >
 <img
 className="img-fluid"
 src="assets/img/destination-1.jpg"
 alt=""
 />
 <div className="bg-white text-danger fw-bold position-absolute top-0 start-0 m-3 py-1 px-2">
 30% DE RÉDUCTION
 </div>
 <div className="bg-white text-primary fw-bold position-absolute bottom-0 end-0 m-3 py-1 px-2">
 Thaïlande
 </div>
 </a>
 </div>
 <div
 className="col-lg-6 col-md-12 wow zoomIn"
 data-wow-delay="0.3s"
 >
 <a
 className="position-relative d-block overflow-hidden"
 href=""
 >
 <img
 className="img-fluid"
 src="assets/img/destination-2.jpg"
 alt=""
 />
 <div className="bg-white text-danger fw-bold position-absolute top-0 start-0 m-3 py-1 px-2">
 25% DE RÉDUCTION
 </div>
 <div className="bg-white text-primary fw-bold position-absolute bottom-0 end-0 m-3 py-1 px-2">
 Malaisie
 </div>
 </a>
 </div>
 <div
 className="col-lg-6 col-md-12 wow zoomIn"
 data-wow-delay="0.5s"
 >
 <a
 className="position-relative d-block overflow-hidden"
 href=""
 >
 <img
 className="img-fluid"
 src="assets/img/destination-3.jpg"
 alt=""
 />
 <div className="bg-white text-danger fw-bold position-absolute top-0 start-0 m-3 py-1 px-2">
 35% DE RÉDUCTION
 </div>
 <div className="bg-white text-primary fw-bold position-absolute bottom-0 end-0 m-3 py-1 px-2">
 Australie
 </div>
 </a>
 </div>
 </div>
 </div>
 <div
 className="col-lg-5 col-md-6 wow zoomIn"
 data-wow-delay="0.7s"
 style={{ minHeight: 350 }}
 >
 <a
 className="position-relative d-block h-100 overflow-hidden"
 href=""
 >
 <img
 className="img-fluid position-absolute w-100 h-100"
 src="assets/img/destination-4.jpg"
 alt=""
 style={{ objectFit:"cover" }}
 />
 <div className="bg-white text-danger fw-bold position-absolute top-0 start-0 m-3 py-1 px-2">
 20% DE RÉDUCTION
 </div>
 <div className="bg-white text-primary fw-bold position-absolute bottom-0 end-0 m-3 py-1 px-2">
 Indonésie
 </div>
 </a>
 </div>
 </div>
 </div>
 </div>
 {/* Destination Start */}
 </div>
 )
}

export default Destination